import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Container } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import content, { contentPropTypes } from './NewPaymentDatesModal.content';
import withContent from '../../../../containers/withContent';

export const NewPaymentDatesModal = ({
	content: { header, description, dateNoteDescription, oKButtonTitle, settlementDateTitle },
	rates: { settlementDate, isSettlementDateUpdated },
	updateNewPaymentDates,
	newPaymentDateAcknowledged,
}) => (
	<Modal isOpen={!!isSettlementDateUpdated && !newPaymentDateAcknowledged} shouldCloseOnOverlayClick={false}>
		<Container className="modal__container u-padding-y-4 u-text-align-center">
			<h2>{header}</h2>
			<div>
				<p>{description}</p>
				<p>{`${settlementDateTitle} ${settlementDate}`}</p>
				<p>{dateNoteDescription}</p>
				<div>
					<Button id="NewPaymentDates" display="primary" onClick={updateNewPaymentDates} width="flush">
						{oKButtonTitle}
					</Button>
				</div>
			</div>
		</Container>
	</Modal>
);

NewPaymentDatesModal.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	rates: PropTypes.shape({}),
	updateNewPaymentDates: PropTypes.func,
	newPaymentDateAcknowledged: PropTypes.bool,
};
export default compose(withContent({ content }))(NewPaymentDatesModal);
